<template>
    <default-modal
        ref="box"
        :title="title"
        :modalWidth="600"
        :confirmBtn="false"
        @cancel="cancel"
    >
        <div class="modal-body">
            <div class="tips">
                <div>
                    <span style="font-weight:700;">「安全组」</span
                    >是主动防御功能中的一个概念。通过安全组，你可以跨网吧管理分组，将网吧按照自己的需求进行归类管理，以便能更加方便的为网吧分配规则。
                </div>
                <div style="color:#D9001B;">
                    注：默认安全组不允许改名和删除，新注册网吧将自动分配至该分组。
                </div>
            </div>
            <div class="table">
                <div class="table-header row">
                    <div>
                        安全组名称
                    </div>
                    <div>
                        网吧数
                    </div>
                    <div>
                        操作
                    </div>
                </div>
                <div class="table-body">
                    <div
                        class="row"
                        v-for="(item, index) in tableList"
                        :key="index"
                    >
                        <!-- 安全组名称  -->
                        <div class="name">
                            <span
                                v-text="item.securityName"
                                v-show="!item.editState"
                            ></span>
                            <input
                                type="text"
                                v-model="item.editName"
                                v-show="item.editState"
                            />
                        </div>
                        <!-- 网吧数 -->
                        <div>
                            <span v-text="item.barNum"></span>
                        </div>
                        <div v-show="!item.editState && item.id != 1">
                            <a href="#" @click.prevent="item.editState = true"
                                >更改组名</a
                            >
                            <a href="#" @click.prevent="delGroupName(item)"
                                >删除分组</a
                            >
                        </div>
                        <div v-show="item.editState && item.id != 1">
                            <a href="#" @click.prevent="saveEdit(item)"
                                >保存修改</a
                            >
                            <a href="#" @click.prevent="item.editState = false"
                                >取消</a
                            >
                        </div>
                    </div>
                    <no-data
                        style="height:auto;padding-top:20px;padding-bottom:20px;"
                        v-show="tableList.length == 0 || loading"
                        :nodata="tableList.length == 0 && !loading"
                        :loading="loading"
                    ></no-data>
                </div>
            </div>
            <div class="addGroupName">
                <input
                    type="text"
                    placeholder="最长16个汉字"
                    v-model="groupName"
                />
                <a href="#" @click.prevent="addGroup" class="blue-btn">添加</a>
                <span class="wrong-word" ref="wrong" v-text="wrong"></span>
            </div>
        </div>
    </default-modal>
</template>
<script>
import DefaultModal from "_c/modals/defaultModal";
import NoData from "_c/noData/noData";
import { editSecurityGroup, delSecurityGroup } from "@/requests/securityCenter";
import { mapState, mapActions } from "vuex";
export default {
    components: {
        DefaultModal,
        NoData
    },
    data() {
        return {
            title: "网吧安全组管理",
            successFn: "",
            tableList: [],
            loading: false,
            groupName: "",
            wrong: ""
        };
    },
    computed: {
        ...mapState({
            allSecurityGroup: state => state.securityCenter.allSecurityGroup
        })
    },
    watch: {
        allSecurityGroup() {
            let arr = JSON.parse(JSON.stringify(this.allSecurityGroup));
            arr.forEach(item => {
                item.editState = false;
                item.editName = item.securityName;
            });
            this.tableList = arr;
        }
    },
    mounted() {
        window.$modal.safeGroupManage = {};
        window.$modal.safeGroupManage.show = () => {
            return new Promise(resolve => {
                this.init(() => {
                    resolve(true);
                });
            });
        };
    },
    methods: {
        ...mapActions(["securityCenter/actionSetSecurityInfo"]),
        // 初始化信息
        init(fn) {
            this.successFn = fn;
            this.$refs.box.show();
        },
        setWrong(txt) {
            this.wrong = txt;
            this.$domFn.shake(this.$refs.wrong);
        },
        async addGroup() {
            this.wrong = "";
            let vdt = this.$validateCenter.groupName(this.groupName);
            if (!vdt.res) {
                this.wrong = vdt.msg;
                return false;
            }
            let res = await editSecurityGroup({
                id: "",
                securityName: this.groupName
            });
            if (res.code == 200) {
                this.groupName = "";
                await this["securityCenter/actionSetSecurityInfo"]();
                this.$forceUpdate();
            } else {
                this.setWrong(res.msg);
            }
        },
        async delGroupName(item) {
            let res = await delSecurityGroup({
                id: item.id
            });
            if (res.code === 200) {
                this["securityCenter/actionSetSecurityInfo"]();
                this.$forceUpdate();
            } else {
                this.setWrong(res.msg);
            }
        },
        async saveEdit(item) {
            this.wrong = "";
            let vdt = this.$validateCenter.groupName(item.editName);
            if (!vdt.res) {
                this.wrong = vdt.msg;
                return false;
            }
            let res = await editSecurityGroup({
                id: item.id,
                securityName: item.editName
            });
            if (res.code == 200) {
                this["securityCenter/actionSetSecurityInfo"]();
                this.$forceUpdate();
                this.successFn();
            } else {
                this.setWrong(res.msg);
            }
        },
        cancel() {
            this.$router.push({
                path: this.$PAGE_API.home.children.securityCenter.children.index
                    .children.barManageSecurityGroup.path
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";
.modal-body {
    padding: 10px 20px;
    text-align: left;
    position: relative;
    .tips {
        border: 1px solid rgba(215, 215, 215, 1);
        background: rgba(251, 251, 251, 1);
        padding: 5px;
        margin-bottom: 15px;
    }
    .table {
        max-height: 382px;
        overflow-y: auto;
        .row {
            width: 100%;
            cursor: pointer;
            @include clearfix();
            &:after {
                content: "";
                top: 0;
                left: 0;
                display: block;
                font-size: 0;
                height: 0;
                width: 0;
                clear: both;
                visibility: hidden;
            }
            > div {
                float: left;
                text-align: left;
                text-overflow: ellipsis;
                height: 50px;
                span {
                    @include ellipsis();
                    max-width: 100%;
                }
                p {
                    @include ellipsis();
                    max-width: 100%;
                }
                a {
                    text-align: left;
                    text-indent: 0px;
                    margin-right: 8px;
                    color: #02a7f0;
                }
                input {
                    width: 194px;
                    height: 23px;
                    border: 1px solid rgba(2, 167, 240, 1);
                    background: #fff;
                    cursor: pointer;
                    padding-left: 5px;
                }
            }
            > div:nth-child(1) {
                text-indent: 10px;
                width: 40%;
                text-align: left;
            }
            > div:nth-child(2) {
                width: 25%;
                text-align: center;
            }
            > div:nth-child(3) {
                width: 30%;
                text-align: left;
            }
        }

        .table-header {
            > div {
                height: 30px;
                line-height: 30px;
            }
        }
    }
    .addGroupName {
        input {
            width: 212px;
            height: 32px;
            border: 1px solid rgba(215, 215, 215, 1);
            padding-left: 5px;
            margin-right: 10px;
        }
        .wrong-word {
            color: #ff3333;
            display: inline-block;
            margin-left: 10px;
        }
        position: absolute;
        bottom: -54px;
    }
}
</style>
